import React from "react"
import { Banner } from "@shopify/polaris"
import { useTranslation } from "react-i18next"

const OlderLighthouseReportBanner = () => {
  const { t } = useTranslation()

  return (
    <Banner status="warning">
      {t("analyze:websites.older_lighthouse_report_banner")}
    </Banner>
  )
}

export default OlderLighthouseReportBanner
